module.exports = __webpack_public_path__ + "img/bg_multiple_table.9bed211c.png";